import React from "react";
import { Link } from "react-router-dom";

const BrandMark = ({ to = "/", compact = false, large = false }) => (
  <Link
    to={to}
    className={`sidebar-brand wordmark${compact ? " compact" : ""}${large ? " large" : ""}`}
    aria-label="Marsilya Bet"
  >
    <img src="/logo.png" alt="Marsilya" />
  </Link>
);

export default BrandMark;
